import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { GetOrderDetails } from "../../../../services"; // Update service import as needed
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";
import swal from "sweetalert";

const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-trash"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 0a.5.5 0 0 1 .5.5V1h10V.5a.5.5 0 0 1 1 0V1h1a.5.5 0 0 1 0 1h-1v12.5a.5.5 0 0 1-1 0V2H2v11.5a.5.5 0 0 1-1 0V2H0a.5.5 0 0 1 0-1h1V.5a.5.5 0 0 1 .5-.5zM3 2h10v1H3V2zM1 4h14v11a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4z" />
  </svg>
);

export default class PreordersView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preordersList: [],
      filteredList: [], // Initialize filteredList
      isLoaded: false,
      error: null,
      searchQuery: "", // Initialize searchQuery
      selectedStatus: "",
      orderMatchMap: {},
    };
  }

  handleBack() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ isLoaded: true });
    await this.fetchPreorders();
  }

  async fetchPreorders() {
    try {
      let response = await GetOrderDetails.getAllPreOrderList();
      if (response && response.success) {
        // Sort preorders by createdAt date in descending order (latest to oldest)
        const sortedPreorders = response.preorders.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        this.setState({
          preordersList: sortedPreorders,
          filteredList: sortedPreorders, // Initialize filteredList with sorted preorders
          isLoaded: false,
        });
      } else {
        this.setState({
          preordersList: [],
          filteredList: [], // Reset filteredList
          isLoaded: false,
          error: response.message || "Failed to fetch preorders",
        });
      }
    } catch (error) {
      this.setState({
        error: "An error occurred while fetching preorders",
        isLoaded: false,
      });
      console.error("Error fetching preorders:", error);
    }
  }

async handleRefetchPayment(orderId, preorderId) {
  try {
    let paymentData = {};
    let updatedStatus = "";

    if (orderId.startsWith("order")) {
      // ✅ Razorpay flow
      const res = await GetOrderDetails.getRazorpayOrderInfo(orderId);
      if (res && res.success) {
        paymentData.razorpay = res.data;
        updatedStatus = res.data.status || "Unknown";
      } else {
        NotificationManager.error(res.message || "Could not fetch Razorpay order", "Error");
        return;
      }
    } else if (orderId.startsWith("APP")) {
      // ✅ HDFC flow
      const response = await fetch(`https://jccreations.boutique/api/order/hdfcresponse?order_id=${orderId}`);
      const parsedResponse = await response.json();

      if (parsedResponse && parsedResponse.status) {
        paymentData.hdfc = parsedResponse;
        updatedStatus = parsedResponse.status || "Unknown";
      } else {
        NotificationManager.error("Could not fetch HDFC order status", "Error");
        return;
      }
    }

    // ✅ Update preordersList with payment info and status
    const updatedList = this.state.preordersList.map((pre) =>
      pre.id === preorderId
        ? { ...pre, ...paymentData, status: updatedStatus }
        : pre
    );

    this.setState({ preordersList: updatedList }, () => {
      this.filterCustomers();
    });

    NotificationManager.success("Payment info updated successfully!", "Success");
  } catch (error) {
    console.error("Error fetching payment info:", error);
    NotificationManager.error("Error fetching payment info", "Error");
  }
}

  
  async handleCheckOrderMatch(orderNumber, preorderId) {
    try {
      const res = await GetOrderDetails.checkOrderInOrders(orderNumber);
      if (res.success) {
        const matchStatus = res.exists ? "Matched" : "Not Found";
        this.setState((prevState) => ({
          orderMatchMap: {
            ...prevState.orderMatchMap,
            [preorderId]: matchStatus,
          },
        }));
        NotificationManager.info(`Order ${matchStatus}`, "Order Match Status");
      } else {
        NotificationManager.error("Unable to verify order", "Error");
      }
    } catch (error) {
      console.error("Error checking order match:", error);
      NotificationManager.error("Internal server error", "Error");
    }
  }
  

  
  async handleMoveToOrder(id) {
    swal({
      title: "Are you sure?",
      text: "You want to move this preorder to the Orders list",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        let result = await GetOrderDetails.movePreorderToOrder(id);
        if (result) {
          NotificationManager.success(result.msg, "Status");
          this.setState((prevState) => ({
            preordersList: prevState.preordersList.filter((pre) => pre.id !== id),
            filteredList: prevState.filteredList.filter((pre) => pre.id !== id),
          }));
          
        }
      }
    });
  }

  handleSearch(e) {
    const query = e.target.value.toLowerCase();
    this.setState({ searchQuery: query }, () => {
      this.filterCustomers();
    });
  }

  handleStatusFilter(e) {
    this.setState({ selectedStatus: e.target.value }, () => {
      this.filterCustomers();
    });
  }
  

  filterCustomers() {
    const { preordersList, searchQuery, selectedStatus } = this.state;
  
    const filteredList = preordersList.filter((preorder) => {
      const matchesSearch =
        preorder.customer &&
        (preorder.customer.fullName.toLowerCase().includes(searchQuery) ||
          preorder.customer.email.toLowerCase().includes(searchQuery) ||
          preorder.customer.phone.toLowerCase().includes(searchQuery));
  
      const matchesStatus =
        !selectedStatus || // if no filter applied, show all
        (preorder.razorpay && preorder.razorpay.status === selectedStatus);
  
      return matchesSearch && matchesStatus;
    });
  
    this.setState({ filteredList });
  }
  

  async handleDeletePreorder(id) {
    swal({
      title: "Are you sure?",
      text: "You want to delete this preorder",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let result = await GetOrderDetails.deletePreOrder(id);
          if (result.success) {
            NotificationManager.success(result.msg, "Status");
            this.setState((prevState) => ({
              preordersList: prevState.preordersList.filter((pre) => pre.id !== id),
              filteredList: prevState.filteredList.filter((pre) => pre.id !== id),
            }));
            
          } else {
            NotificationManager.error(
              result.message || "Failed to delete preorder",
              "Error"
            );
          }
        } catch (error) {
          console.error("Error deleting preorder:", error);
          NotificationManager.error(
            "An error occurred while deleting the preorder",
            "Error"
          );
        }
      }
    });
  }

  render() {
    const { filteredList, isLoaded, error, searchQuery } = this.state; // Use filteredList instead of preordersList
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">Preorders List</h2>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button variant="contained" onClick={() => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item active">Preorders</li>
        </ol>
        <div className="row">
          <div className="col-lg-5 col-md-6">
            <div className="bulk-section mt-30">
            <div className="bulk-section mt-30">
  <div className="search-by-name-input" style={{ display: "flex", gap: "10px" }}>
    <input
      type="text"
      className="form-control"
      placeholder="Search"
      value={searchQuery}
      onChange={(e) => this.handleSearch(e)}
    />
    <select
      className="form-control"
      onChange={(e) => this.handleStatusFilter(e)}
      value={this.state.selectedStatus}
    >
      <option value="">All Status</option>
      <option value="created">Created</option>
      <option value="paid">Paid</option>
      <option value="attempted">Attempted</option>
    </select>
  </div>
</div>

            </div>
          </div>
          
          <div className="col-lg-12 col-md-12">
            {isLoaded ? <Loader /> : ""}{" "}
        
            {error && <div className="alert alert-danger">{error}</div>}{" "}
        
            <div className="card card-static-2 mt-30 mb-30">
              <div className="card-title-2">
                <h4>All Preorders</h4>
              </div>
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>ID</th>
                        <th>Date</th>
                        <th>Customer Full Name</th>
                        <th>Customer Email</th>
                        <th>Customer Phone</th>
                        <th>Order ID</th>
                        <th>Order Details</th>
                        <th>Total Amount</th>
                        <th>Payment Info</th> {/* 👈 New column */}
                        <th>Order Match</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(filteredList) &&
                      filteredList.length > 0 ? (
                        filteredList.map((row, index) => {
                          const createdAt = new Date(row.createdAt);
                          const options = {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          };
                          const formattedDate = createdAt.toLocaleString(
                            "en-IN",
                            options
                          );

                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{formattedDate}</td>
                              <td>
                                {row.customer
                                  ? row.customer.fullName
                                  : "Unknown"}
                              </td>
                              <td>
                                {row.customer ? row.customer.email : "Unknown"}
                              </td>
                              <td>
                                {row.customer ? row.customer.phone : "Unknown"}
                              </td>
                              <td>{row.number}</td>
                              <td>
                                {" "}
                                {row.preorderPaths &&
                                row.preorderPaths.length > 0 ? (
                                  row.preorderPaths.map((product, i) => (
                                    <div key={i}>
                                      <strong>{product.productName}</strong>
                                      {product.variants &&
                                      product.variants.length > 0 ? (
                                        product.variants.map((variant, j) => (
                                          <div key={j}>
                                            - {variant.variantName}
                                          </div>
                                        ))
                                      ) : (
                                        <div>No Variants Available</div>
                                      )}
                                    </div>
                                  ))
                                ) : (
                                  <div>No Products Available</div>
                                )}
                              </td>
                              <td>{row.grandtotal}</td>
                         <td>
  {row.razorpay ? (
    <div>
      <div><strong>Status:</strong> {row.razorpay.status}</div>
      <div><strong>Amount:</strong> ₹{(row.razorpay.amount / 100).toFixed(2)}</div>
      <div><strong>Payment ID:</strong> {row.razorpay.id}</div>
    </div>
  ) : row.hdfc ? (
    <div>
      <div><strong>Status:</strong> {row.hdfc.status}</div>
      <div><strong>Amount:</strong> ₹{(row.hdfc.amount / 100).toFixed(2)}</div>
      <div><strong>Order ID:</strong> {row.hdfc.order_id || row.hdfc.orderId}</div>
      <div><strong>Txn ID:</strong> {row.hdfc.transaction_id || row.hdfc.txnId || "-"}</div>
    </div>
  ) : (
    <div>
      <div>No Payment Info</div>
      <Button
        variant="outlined"
        size="small"
        color="primary"
        onClick={() => this.handleRefetchPayment(row.number, row.id)}
      >
        Refetch
      </Button>
    </div>
  )}
</td>

<td>
  <Button
    variant="outlined"
    size="small"
    onClick={() => this.handleCheckOrderMatch(row.number, row.id)}
  >
    Check Order
  </Button>
  <div style={{ fontSize: "12px", marginTop: "4px" }}>
    {this.state.orderMatchMap[row.id] && (
      <span
        style={{
          color: this.state.orderMatchMap[row.id] === "Matched" ? "green" : "red",
          fontWeight: "bold",
        }}
      >
        {this.state.orderMatchMap[row.id]}
      </span>
    )}
  </div>
</td>


                              <td>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => this.handleMoveToOrder(row.id)}
                                >
                                  Move to Order
                                </Button>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() =>
                                    this.handleDeletePreorder(row.id)
                                  }
                                  style={{ marginLeft: "8px" }}
                                >
                                  <DeleteIcon />
                                </Button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center" }}>
                            No Preorders Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/preorder/view/index.js